const AppConfig = {
    apiUrl: "https://api-kvasir.digneety.net",
    //apiUrl: "https://localhost:7065",
}

export default AppConfig;